exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".DvIaI1KKprmgPHG0INgMy {\n  display: block;\n  text-align: left;\n  margin-bottom: 32px;\n}\n.DvIaI1KKprmgPHG0INgMy button {\n  text-transform: uppercase;\n}\n.ahUb-eSwnyz7ne4q-85mB {\n  margin-bottom: 32px;\n}\n@media (max-width: 540px) {\n  .ahUb-eSwnyz7ne4q-85mB {\n    margin-bottom: 16px;\n  }\n}\n.ahUb-eSwnyz7ne4q-85mB.vKaaiPw6mXUcYJmcsAeGO {\n  opacity: 0.6;\n  pointer-events: none;\n}\n", ""]);

// exports
exports.locals = {
	"forgetPasswordLink": "DvIaI1KKprmgPHG0INgMy",
	"userName": "ahUb-eSwnyz7ne4q-85mB",
	"disabled": "vKaaiPw6mXUcYJmcsAeGO"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--4-2!./node_modules/postcss-loader/lib??postcss!./node_modules/less-loader/dist/cjs.js!./src/client/Components/LoginForm/LoginForm.css
// module id = 2218
// module chunks = 35